import { render, staticRenderFns } from "./areaRecordingMonths.vue?vue&type=template&id=5600cc06&scoped=true&"
import script from "./areaRecordingMonths.vue?vue&type=script&lang=js&"
export * from "./areaRecordingMonths.vue?vue&type=script&lang=js&"
import style0 from "./areaRecordingMonths.vue?vue&type=style&index=0&id=5600cc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600cc06",
  null
  
)

export default component.exports